import React, { useState, useEffect } from "react";
import BookmarkPopUp from "../PopUp/BookmarkpopUpMyLinks";

export default function GenAIMyLinks({ showLinksText, customWidth, updateBMAddForHome }) {
    const [showBookmarkPopUp, setshowBookmarkPopUp] = useState(false);
    const openBookmarkpopUp = () => {
        setshowBookmarkPopUp(true)
    }
    return (<>
        <div className="ccai-links-button" onClick={openBookmarkpopUp}>
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_299_1238)">
                    <path d="M6.66661 8.66666C6.9529 9.04942 7.31816 9.36612 7.73761 9.59529C8.15706 9.82446 8.62088 9.96074 9.09763 9.99489C9.57437 10.029 10.0529 9.96024 10.5007 9.79319C10.9485 9.62613 11.3552 9.36471 11.6931 9.02666L13.693 7.02666C14.3002 6.39799 14.6362 5.55598 14.6286 4.68199C14.621 3.808 14.2704 2.97196 13.6524 2.35394C13.0344 1.73591 12.1984 1.38535 11.3245 1.37775C10.4505 1.37016 9.60852 1.70614 8.97986 2.31333L7.83324 3.45333M9.33319 7.33333C9.04689 6.95058 8.68164 6.63388 8.26219 6.4047C7.84274 6.17553 7.37892 6.03925 6.90217 6.00511C6.42543 5.97096 5.94691 6.03975 5.49909 6.20681C5.05127 6.37387 4.64461 6.63528 4.3067 6.97333L2.30677 8.97333C1.69959 9.602 1.36363 10.444 1.37122 11.318C1.37881 12.192 1.72936 13.028 2.34737 13.6461C2.96538 14.2641 3.80139 14.6147 4.67535 14.6222C5.5493 14.6298 6.39128 14.2939 7.01993 13.6867L8.15989 12.5467" stroke="#212121" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                </g>
                <defs>
                    <clipPath id="clip0_299_1238">
                        <rect width="15.9994" height="16" fill="white" />
                    </clipPath>
                </defs>
            </svg>
            <div className="ccai-links-text">{showLinksText}</div>
        </div>
        {
            showBookmarkPopUp &&
            <BookmarkPopUp showModal={showBookmarkPopUp} handleClose={() => setshowBookmarkPopUp(false)} customWidth={customWidth} updateBMAddForHome={updateBMAddForHome} />
        }
    </>)

}